import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ToastrModule } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonInterceptorService } from './core/services/common-interceptor.service';
import { CommunityModule } from './modules/community/community.module';
import { MessageCenterModule } from './modules/message-center/message-center.module';
import { ChatEmitterService } from './core/services/chat-emitter.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxLinkifyjsModule } from 'ngx-linkifyjs';
import { MsalModule, MsalInterceptor, MsalGuard } from '@azure/msal-angular';
import { Configuration } from 'msal';
import { environment } from '@env/environment';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    // angular
    BrowserModule,

    //  shared
    SharedModule,

    // app
    AppRoutingModule,

    CommunityModule,

    MessageCenterModule,

    ToastrModule.forRoot({
      timeOut: 3000,
      closeButton: true,
      tapToDismiss: true,
      positionClass: 'toast-top-right',
      preventDuplicates: true
    }),
    BrowserAnimationsModule,
    NgxLinkifyjsModule.forRoot({ enableHash: false, enableMention: false }),
    MsalModule.forRoot(environment.msalConfig as Configuration)
  ],
  /* Changes end here. */
  providers: [CookieService, ChatEmitterService,
    { provide: HTTP_INTERCEPTORS, useClass: CommonInterceptorService, multi: true },
    MsalGuard           
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
